<template lang='pug'>
  el-dialog(title="提交工作报告", :visible.sync="visible")
    div(style="margin-bottom:5px;") {{ word }}
    el-autocomplete(
      v-if="showReason"
      class="inline-input"
      v-model="reason"
      :fetch-suggestions="querySearch"
      placeholder="请填写未完成理由")
    span(slot="footer")
      el-button(@click="cancel", type="primary") {{ cancelTxt }}
      el-button(@click="submit") {{ submitTxt }}
</template>

<script>
// Generated by CoffeeScript 2.3.0
var dateFormat, m;

dateFormat = require('dateformat');

export default m = {
  data: function() {
    return {
      visible: false,
      finish: 0,
      now: 0,
      word: '',
      cancelTxt: '',
      submitTxt: '',
      showReason: false,
      reason: ''
    };
  },
  methods: {
    show: function(now) {
      var cha, today;
      today = dateFormat(new Date(), 'yyyy-mm-dd');
      this.now = now;
      if (!app.user.goal_date || app.user.goal_date !== today || app.user.goal_num) {
        this.finish = Math.round((parseInt(now) / parseInt(app.user.goal_num)) * 100);
        if (this.finish >= 100) {
          this.word = `今天已经完成了任务的${this.finish}%，是否再挑战一下呢?`;
          this.cancelTxt = "继续挑战";
          this.submitTxt = "不挑战了";
        } else {
          cha = parseInt(app.user.goal_num) - parseInt(now);
          this.word = `今天还没完成任务哦！还差${cha}个`;
          this.cancelTxt = "继续努力";
          this.submitTxt = "不努力了";
          this.showReason = true;
        }
        return this.visible = true;
      } else {
        return this.$parent.$refs.goal.show();
      }
    },
    hide: function() {
      return this.visible = false;
    },
    cancel: function() {
      return this.hide();
    },
    submit: function() {
      if (this.finish < 100 && !this.reason) {
        this.$message({
          type: 'info',
          message: '请填写未完成理由'
        });
        return;
      }
      return app.api.find({
        tableName: 'goals',
        query: {
          name: app.user.account,
          goal_date: app.user.goal_date
        }
      }).then((goals) => {
        if (goals.length > 0) {
          return app.api.update({
            tableName: 'goals',
            _id: goals[0]._id,
            data: {
              goal: app.user.goal,
              goal_num: app.user.goal_num,
              actual: this.now,
              reason: this.reason
            }
          });
        } else {
          return app.api.create({
            tableName: 'goals',
            data: {
              name: app.user.account,
              goal: app.user.goal,
              goal_num: app.user.goal_num,
              actual: this.now,
              goal_date: app.user.goal_date,
              reason: this.reason,
              permissions: {
                "所有人": "读写"
              }
            }
          });
        }
      }).then(() => {
        this.$message({
          type: 'success',
          message: '提交成功'
        });
        return this.hide();
      });
    },
    querySearch: function(queryString, cb) {
      var reasons;
      reasons = [
        {
          value: '心情不好'
        },
        {
          value: '太累了'
        }
      ];
      return cb(reasons);
    }
  }
};
</script>

